export default __webpack_public_path__ + "b3ff82f32b71d1a30e297db20ce45038.webp";